import React from 'react';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Marco Rossi',
    age: 34,
    location: 'Roma, Italia',
    text: 'Questo Mega-Pack mi ha cambiato la vita! Prima passavo i weekend a cercare idee, ora ho tutto pronto. I miei alunni adorano i nuovi percorsi motori.'
  }, {
    name: 'Giulia Bianchi',
    age: 41,
    location: 'Milano, Italia',
    text: 'Materiale eccellente e molto ben organizzato. I bonus sono fantastici, specialmente i giochi veloci per attivare la classe nei primi 5 minuti.'
  }, {
    name: 'Alessandro Conti',
    age: 29,
    location: 'Napoli, Italia',
    text: "Come insegnante al primo anno ero un po' perso. Questa guida mi ha dato la struttura e la sicurezza di cui avevo bisogno. Consigliatissimo!"
  }, {
    name: 'Francesca Marino',
    age: 38,
    location: 'Torino, Italia',
    text: 'Incredibile il valore di questo pacchetto. Le schede di valutazione mi fanno risparmiare tantissimo tempo a fine mese. Un investimento perfetto.'
  }, {
    name: 'Chiara Ferretti',
    age: 45,
    location: 'Firenze, Italia',
    text: 'Insegno da 20 anni e pensavo di aver visto tutto, ma ho trovato tantissime idee fresche e innovative. I ragazzi partecipano con molto più entusiasmo.'
  }];
  return <section className="py-16 px-4 bg-gray-50" data-id="element-279">
      <div className="max-w-6xl mx-auto" data-id="element-280">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-281">
          Migliaia di insegnanti utilizzano già questi materiali
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-282">
          {testimonials.map((t, idx) => <div key={idx} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col" data-id="element-283">
              <div className="flex text-yellow-400 mb-4" data-id="element-284">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-285" />)}
              </div>
              <p className="text-gray-700 italic mb-6 flex-1" data-id="element-286">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="border-t border-gray-100 pt-4" data-id="element-287">
                <p className="font-bold text-gray-900" data-id="element-288">
                  {t.name}, {t.age} anni
                </p>
                <p className="text-sm text-gray-500" data-id="element-289">{t.location}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}